import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  personalityReportPersonalitySaga,
  personalityReportValuesSaga,
  personalityReportVisionSaga,
} from '../api/repositories/personalityReport/personalityReport.sagas';
import { handleAsyncStatus } from '../asynchronousState/saga';
import { EAsyncEventTypes } from '../asynchronousState/types';
import { ActionsOfType } from '../helpers';
import {
  EPersonalityReportActions,
  IPersonalityReportAction,
  personalityReportActions,
} from './actions';

export function* getPersonalityReport(
  action: ActionsOfType<IPersonalityReportAction, EPersonalityReportActions.GET>
) {
  const { values, vision, personality } = yield all({
    values: call(personalityReportValuesSaga, action.payload.accountId),
    vision: call(personalityReportVisionSaga, action.payload.accountId),
    personality: call(
      personalityReportPersonalitySaga,
      action.payload.accountId
    ),
  });

  yield put(
    personalityReportActions.getPersonalityReportSuccess({
      values,
      vision,
      personality,
    })
  );
}

export function* getPersonalityReportVision(
  action: ActionsOfType<
    IPersonalityReportAction,
    EPersonalityReportActions.GET_VISION
  >
) {
  const vision = yield call(
    personalityReportVisionSaga,
    action.payload.accountId
  );

  yield put(
    personalityReportActions.getPersonalityReportVisionSuccess({ vision })
  );
}

export function* personalityReportRootSaga() {
  yield all([
    takeLatest(
      EPersonalityReportActions.GET,
      handleAsyncStatus(
        getPersonalityReport,
        EAsyncEventTypes.GET_PERSONALITY_REPORT
      )
    ),
    takeLatest(
      EPersonalityReportActions.GET_VISION,
      handleAsyncStatus(
        getPersonalityReportVision,
        EAsyncEventTypes.GET_PERSONALITY_REPORT_VISION
      )
    ),
  ]);
}
